// Icons taken from: https://icon-sets.iconify.design/
// Mostly using the style of `Material Design Icons`
export enum AppIcon {
  ARROW_DOWN = "arrow-down",
  CHEVRON_DOWN = "chevron-down",
  CHEVRON_UP = "chevron-up",
  CHEVRON_LEFT = "chevron-left",
  CHEVRON_RIGHT = "chevron-right",
  FILE_EXPORT = "file-export",
  DOWNLOAD = "download",
  OPEN_LINK = "open-link",
  LINK = "link",
  PHONE = "phone",
  PLUS = "plus",
  EMAIL = "email",
  WORLD = "world",
  CANCEL = "cancel",
  CHECK = "check",
  SEARCH = "search",
  USER = "user",
  LOGO = "logo-ritello",
  HAMBURGER = "hamburger",
  NOTIFICATION = "notification",
  ANNOUNCEMENT = "announcement",
  WAREHOUSE = "warehouse",
  BOOKING = "booking",
  DEMO = "demo",
  SALE = "sale",
  VISIT = "visit",
  SCHEDULE = "calendar",
  EYE = "eye",
  EYE_OFF = "eye-off",
  DESC = "desc",
  ASC = "asc",
  CUSTOMER = "customer",
  CUSTOMER_BOOKING = "customer-booking",
  CUSTOMER_LOCATION = "customer-location",
  CUSTOMER_CONTACT = "customer-contact",
  LOCATION = "location",
  LOCATION_COUNTRY = "location-country",
  LOCATION_CITY = "location-city",
  LOCATION_ADDRESS = "location-address",
  ADD_CUSTOMER = "add-customer",
  ADD_ADDRESS = "add-address",
  EDIT_PENCIL = "edit-pencil",
  ASSIGNED_INVENTORY = "assigned-inventory",
  ASSIGNED_EQUIPMENT = "assigned-equipment",
  INVENTORY = "inventory",
  CAMPAIGN = "campaign",
  REWARD = "reward",
  LOGOUT = "logout",
  EVENT = "event",
  QR_CODE = "qr-code",
  QR_CODE_SCANNER = "qr-code-scanner",
  //Equipment
  EQUIPMENT = "equipment",
  EQUIPMENT_TYPE = "equipment-type",
  EQUIPMENT_TRANSFER = "equipment-transfer",

  //Filter
  FILTER = "filter",
  FILTER_RESET = "filter-reset",
}
